import { render, staticRenderFns } from "./user-info-edit.vue?vue&type=template&id=7f31d147&scoped=true"
import script from "./user-info-edit.vue?vue&type=script&lang=js"
export * from "./user-info-edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f31d147",
  null
  
)

export default component.exports